import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import {
  getColumnKey,
  Icon,
  IconComponent,
  NoDataComponent,
  TableBodyNoReferenceCellComponent,
  TableColumn,
} from '@web/shared/ui';
import { isNotNil } from '@web/utils';
import {
  InvoiceKsefStatusComponent,
  InvoiceStatusComponent,
  InvoiceTypeComponent,
} from '@web/shared/module/shop';
import { Tooltip } from 'primeng/tooltip';
import { AdminInvoiceCollectionItem } from '../../models/admin-invoice-collection-item';
import { AdminInvoiceCollectionFilter } from '../../models/admin-invoice-collection-filter';

@Component({
  selector: 'app-admin-invoice-list-custom-cell-template',
  imports: [
    TableBodyNoReferenceCellComponent,
    InvoiceKsefStatusComponent,
    InvoiceStatusComponent,
    InvoiceTypeComponent,
    IconComponent,
    NoDataComponent,
    Tooltip,
  ],
  templateUrl: './admin-invoice-list-custom-cell-template.component.html',
  styleUrl: './admin-invoice-list-custom-cell-template.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminInvoiceListCustomCellTemplateComponent {
  /* prettier-ignore */
  public readonly column = input.required<TableColumn<AdminInvoiceCollectionItem, AdminInvoiceCollectionFilter>>();
  /* prettier-ignore */
  public readonly model = input.required<AdminInvoiceCollectionItem>();

  /* prettier-ignore */
  protected readonly getColumnKey = getColumnKey<AdminInvoiceCollectionItem>;
  protected readonly isNotNil = isNotNil;
  protected readonly Icon = Icon;
}
